import { PageId } from 'constants/pages'

export const enum PageIdWoofzNdd {
  SUBSCRIPTIONS_NDD = PageId.SUBSCRIPTIONS_NDD,
  CANCEL_OFFER_NDD = PageId.CANCEL_OFFER_NDD,
  CHAT_UPSELL_NDD = PageId.CHAT_UPSELL_NDD,
  UPSELL_NDD = PageId.UPSELL_NDD,
  DOWNLOAD_NDD = PageId.DOWNLOAD_NDD,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
